import { IconContext } from "react-icons";
import { IoInformationCircleOutline, IoCheckmarkCircleOutline, IoCloseCircleOutline, IoAlertCircleOutline } from "react-icons/io5";
import CustomLabel from "../shared/label/custom-label.component";
import { successGreen, success50, errorRed, error50, secondary500, secondary50, netural400 } from "../../constants/color";

const NoticeBanner = ({ title, variant = "info", children, showIcon = true }) => {
  const getVariantStyles = () => {
    switch (variant) {
      case "success":
        return {
          backgroundColor: success50,
          iconColor: successGreen,
          icon: IoCheckmarkCircleOutline,
        };
      case "error":
        return {
          backgroundColor: error50,
          iconColor: errorRed,
          icon: IoCloseCircleOutline,
        };
      case "warning":
        return {
          backgroundColor: "#FFF3DA",
          iconColor: "black",
          icon: IoAlertCircleOutline,
        };
      case "primary":
        return {
          backgroundColor: secondary50,
          iconColor: secondary500,
          icon: IoInformationCircleOutline,
        };
      case "info":
      default:
        return {
          backgroundColor: "#FFF3DA",
          iconColor: "black",
          icon: IoInformationCircleOutline,
        };
    }
  };

  const styles = getVariantStyles();
  const IconComponent = styles.icon;

  return (
    <div
      style={{
        marginBottom: "2%",
        backgroundColor: styles.backgroundColor,
        padding: 16,
        borderRadius: 12,
        display: "flex",
        alignItems: "flex-start",
      }}
    >
      {showIcon && (
        <IconContext.Provider value={{ size: 22, color: styles.iconColor }}>
          <IconComponent style={{ flexShrink: 0, marginTop: 2 }} />
        </IconContext.Provider>
      )}
      <div style={{ marginLeft: showIcon ? 10 : 0, flex: 1 }}>
        {title && (
          <CustomLabel
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: netural400,
              display: "block",
            }}
          >
            {title}
          </CustomLabel>
        )}
        {children && <div style={{ marginTop: title ? 8 : 0 }}>{children}</div>}
      </div>
    </div>
  );
};

export default NoticeBanner;
